import * as React from "react"
import { Flex, Box } from "@chakra-ui/react"
import { defaultOptions } from "./utils"
import { Face } from "./frequent-faces/face"
import { Hair } from "./frequent-faces/hair"
import { Hat } from "./frequent-faces/hat"
import { Eyes } from "./frequent-faces/eyes"
import { Glasses } from "./frequent-faces/glasses"
import { Ear } from "./frequent-faces/ear"
import { Nose } from "./frequent-faces/nose"
import { Mouth } from "./frequent-faces/mouth"
import { Shirt } from "./frequent-faces/shirt"
import { SectionWrapper } from "./SectionWrapper"

interface AvatarEditorProps {
  config: any
  updateConfig: any
  isSmallWidth: boolean
  isLandscape?: boolean
}

export const AvatarEditor: React.FC<AvatarEditorProps> = ({
  config,
  updateConfig,
  isSmallWidth,
  isLandscape
}) => {
  const genDefaultOptions = opts => {
    const hairSet = new Set(opts.hairStyleMan.concat(opts.hairStyleWoman))
    return {
      ...opts,
      hairStyle: Array.from(hairSet)
    }
  }
  const [myDefaultOptions] = React.useState(genDefaultOptions(defaultOptions))

  const switchConfig = (type, currentOpt) => {
    const opts = myDefaultOptions[type]
    const currentIdx = opts.findIndex(item => item === currentOpt)
    const newIdx = (currentIdx + 1) % opts.length
    updateConfig(type, opts[newIdx])
  }

  return (
    <Flex
      background="rgba(0, 0, 0, 0.25);"
      alignItems="center"
      borderRadius="9999px"
      padding={
        isSmallWidth
          ? "0.3rem 0.5rem 0.3rem 0.5rem"
          : "0.5rem 0.75rem 0.5rem 0.75rem"
      }
      width={isSmallWidth ? "100%" : "600px"}
    >
      {config ? (
        <>
          <SectionWrapper
            tip={isSmallWidth ? "" : "Face"}
            switchConfig={() => switchConfig("faceColor", config.faceColor)}
            isSmallWidth={isSmallWidth}
          >
            <Face color={config.faceColor} isEditor={true} />
          </SectionWrapper>
          <SectionWrapper
            tip={isSmallWidth ? "" : "Hair"}
            isSmallWidth={isSmallWidth}
            switchConfig={() => switchConfig("hairStyle", config.hairStyle)}
          >
            <Hair
              style={config.hairStyle}
              color="#fff"
              /* colorRandom */
              isEditor={true}
            />
          </SectionWrapper>
          <SectionWrapper
            tip={isSmallWidth ? "" : "Hat"}
            switchConfig={() => switchConfig("hatStyle", config.hatStyle)}
            isSmallWidth={isSmallWidth}
          >
            <Hat style={config.hatStyle} color="#fff" />
          </SectionWrapper>
          <SectionWrapper
            tip={isSmallWidth ? "" : "Eyes"}
            switchConfig={() => switchConfig("eyeStyle", config.eyeStyle)}
            isSmallWidth={isSmallWidth}
          >
            <Eyes style={config.eyeStyle} isEditor={true} />
          </SectionWrapper>
          <SectionWrapper
            tip={isSmallWidth ? "" : "Glasses"}
            switchConfig={() =>
              switchConfig("glassesStyle", config.glassesStyle)
            }
            isSmallWidth={isSmallWidth}
          >
            <Glasses style={config.glassesStyle} isEditor={true} />
          </SectionWrapper>
          <SectionWrapper
            tip={isSmallWidth ? "" : "Ear"}
            switchConfig={() => switchConfig("earSize", config.earSize)}
            isSmallWidth={isSmallWidth}
          >
            <Ear size={config.earSize} color="#fff" isEditor={true} />
          </SectionWrapper>
          <SectionWrapper
            tip={isSmallWidth ? "" : "Nose"}
            switchConfig={() => switchConfig("noseStyle", config.noseStyle)}
            isSmallWidth={isSmallWidth}
          >
            <Nose style={config.noseStyle} isEditor={true} />
          </SectionWrapper>
          <SectionWrapper
            tip={isSmallWidth ? "" : "Mouth"}
            isSmallWidth={isSmallWidth}
            switchConfig={() => switchConfig("mouthStyle", config.mouthStyle)}
          >
            <Mouth style={config.mouthStyle} isEditor={true} />
          </SectionWrapper>
          <SectionWrapper
            tip={isSmallWidth ? "" : "Shirt"}
            isSmallWidth={isSmallWidth}
            switchConfig={() => switchConfig("shirtStyle", config.shirtStyle)}
          >
            <Shirt style={config.shirtStyle} color="#fff" isEditor={true} />
          </SectionWrapper>{" "}
        </>
      ) : (
        <>
          {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((el, index) => (
            <SectionWrapper isSmallWidth={isSmallWidth} key={"dummyAvatarEditor"+index}>
              <Box></Box>
            </SectionWrapper>
          ))}
        </>
      )}
    </Flex>
  )
}
